const __WEBPACK_NAMESPACE_OBJECT__ = require("license-webpack-plugin");